import Vue from "vue";
import { Button, Popover, Checkbox, CheckboxGroup } from "vant";
Vue.use(Button);
Vue.use(Popover);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
